/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>mediatorEventLookup.model.ts</name>
///
/// <description>
///  A const class that maps event names to event strings
///
/// </description>
///
/// <author>Yaron Habot</author>
/// <created>28 Sept 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
/// 28Sep16 YH  1.0.1            Initial
/// 12Dec16 AA  1.0.1            Added event AccountCreateSelected
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------

export const MediatorEventLookup = {
    CategorySelected: "Event-CategorySelected",
    NavigationContextMenuCommand: "Event-NavigationContextMenuCommand",
    NavigationContextMenuShow: "Event-NavigationContextMenuShow",
    GroupServiceGroupSaved: "Event-GroupServiceGroupSaved",
    GroupSelected: "Event-GroupSelected",
    GroupDeleted: "Event-GroupDeleted",
    GroupRequested: "Event-GroupRequested",
    GroupStatusUpdate: "Event-GroupStatusUpdate",
    GroupUpdate: "Event-GroupUpdate",
    GroupRename: "Event-GroupNameUpdate",   //YH 2/13/2017 Bug 122056. GroupRename is a UI event while GroupUpdate is an API event
    GroupSettingsSave: "Event-GroupSettingsSave", //YH 3/13/2017 Bug 118831
    GroupSettingsRevert: "Event-GroupSettingsRevert", //MM - Bug 124973
    DeviceSelected: "Event-DeviceSelected",
    DeviceAssociated: "Event-DeviceAssociated",
    DeviceUnassociated: "Event-DeviceUnassociated",
    DeviceStatusUpdate: "Event-DeviceStatusUpdate",
    DeviceRename: "Event-DeviceRename",   //YH 2/16/2017 Bug 121330 - [DM] Duplicate Device name is allowed while renaming the devices
    DeviceSettingsSave: "Event-DeviceSettingsSave", //YH 3/10/2017 Bug 118831
    DeviceSettingsRevert: "Event-DeviceSettingsRevert", //YH 3/10/2017 Bug 118831
    //YH 12/1/2016 Task 9542:Revamp Hydrogen Portal left hand side vertical
    AccountSelected: "Event-AccountSelected",
    AccountCreateSelected: "Event-AccountCreateSelected",
    //12/23/2016 SG Demo Fix
    AccountSaved: "Event-AccountSaved",
    RefreshDeviceList: "Event-RefreshDeviceList",
    RefreshDeviceCount: "Event-RefreshDeviceCount",
    PolicySelected: "Event-PolicySelected",
    UserSelected: "Event-UserSelected",
    DeviceClaimed: "Event-DeviceClaimed",
    UserSaved: "Event-UserSaved",
    UserAccessAlertsSaved: "Event-UserAccessAlertsSaved",
    HydrogenLogoClicked: "Event-HydrogenLogoClicked",
    UploadCSVSelected: "Event-UploadCSVSelected",
    UserCreate: "Event-UserCreate", //YH 12/27/2016 Task 9829:Hydrogen Portal - User Management: Add/Remove User from Customer UI
    UserInvite: "Event-UserInvite", //YH 04/17/2017 Bug 123784 - [Users]On creation of a new user, the user does not receive an email to reset the password
    UserUpdateFailed: "Event-UserUpdateFailed",  //YH 2/23/2017 Bug 122703 - [Adhoc] Can create two non- crestron users with duplicate email id
    UserDeleted: "Event-UserDeleted", //YH 5/5/2017 Bug 128885 - After deleting a user, user details don't disappear from detail pane
    AccountNameReset: "Event-AccountNameReset",
    GroupSettingsUpdateSelected: "Event-GroupSettingsUpdate",
    UserActionNotification: "Event-UserActionNotification", //YH 1/11/2017
    UserListReload: "Event-UserListReload", //YH 1/25/2017
    UserListUpdateSelection: "Event-UserListUpdateSelection", //YH 3/7/2017
    UpdateFirmwareVersion: "Event-UpdateFirmwareVersion", //SA 1/20/2017
    LicenseStatusUpdate: "Event-LicenseStatusUpdate",
    ConfirmUnsaveDialogShow: "Event-ConfirmUnsaveDialogShow", //YH 3/7/2017
    ConfirmUnsaveDialogResult: "Event-ConfirmUnsaveDialogResult", //YH 3/7/2017
    HttpErrorEvent: "Event-HttpError",
    LogoutDialogToggle: "Event-LogoutDialogToggle", //YH 3/24/2017
    DebugModeToggle: "Event-DebugModeToggle", //MM 3/28/2017
    DetailFormChanged: "Event-DetailFormChanged",
    PortalManagementCategorySelected: "Event-PortalManagementCategorySelected",
    SettingCategorySelected: "Event-SettingCategorySelected",
    UploadFirmware: "Event-UploadFirmware",
    FwFileUploaded: "Event-FwFileUploaded",
    ReleaseTracks: "Event-ReleaseTracks",
    DeviceCount: "Event-DeviceCount",
    GroupStatusUpdateSelected: "Event-GroupStatusUpdate",
    UpdateBreadCrumb: "Event-UpdateBreadCrumb",
    DeviceMoved: "Event-DeviceMoved",
    GroupMoved: "Event-GroupMoved",
    GroupStatusDragAndDrop: "Event-GroupStatusDragAndDrop",
    ModelTypeChanged: "Event-ModelTypeChanged",
    FileLibrarySelected: "Event-FileLibrarySelected",
    FileListReload: "Event-FileListReload",
    GlobalNotification: "Event-GlobalNotification",
    ChildFileListReload: "Event-ChildFileListReload",
    AddAlertRule: "Event-AddAlertRule",
    DeleteGroup: "Event-DeleteGroup",
    ConfirmDeleteGroup: "Event-ConfirmDeleteGroup",
    ConfirmAutoLogout: "Event-AutoLogout",
    RefreshToken: "Event-RefreshToken",
    AccountCount: "Event-AccountCount",
    ConfirmUnclaimDevice: "Event-ConfirmUnclaimDevice",
    UnclaimDevice: "Event-UnclaimDevice",
    VideoDisplayDriverAdded: "Event-VideoDisplayDriverAdded",
    UnAssociateConfirm: "Event-UnAssociateConfirm",
  UnAssociateDevice: "Event-UnAssociateDevice",
  ShowDashboardToggle: "Event-ShowDashboardToggle"
}




// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/mediator-event-lookup.service.ts